// src/menu-items/numbering.ts
//
// The numbering plans are their own thing: numberingplan-be and -int decide
// which operator owns a number, which is a different question from the caller
// IDs and porting requests in the groups around it.
import { Search, ViewGrid } from 'iconoir-react';

const numbering = {
  id: 'numbering-group',
  title: 'Numbering Plan',
  type: 'group',
  children: [
    {
      id: 'numbering-lookup',
      title: 'Number Lookup',
      type: 'item',
      url: '/numbering/lookup',
      icon: Search,
      breadcrumbs: true
    },
    {
      id: 'numbering-blocks',
      title: 'BE Number Blocks',
      type: 'item',
      url: '/numbering/blocks',
      icon: ViewGrid,
      breadcrumbs: true
    }
  ]
};

export default numbering;
